<template>
  <div class="blankBox">
    <table border="0" cellpadding="0" cellspacing="0" class="selectTb serchFilter" style="padding-left: 0;padding-top: 15px;">
      <tr>
        <td class="td1">
          <!--申请公司-->
          {{ $t('fancingFundList.applyCompany') }}:
        </td>
        <td class="td2">
          <!--请输入内容-->
          <el-input :placeholder="$t('financingFundList.enterPlaceHolder')" v-model.trim="companyName" style="width: 250px;" class="theme-gray" maxlength="50"/>
        </td>
        <td class="td3">
          <!--申请状态：-->
          {{ $t('financingFundList.applyStatus') }}：
        </td>
        <td class="td4">
          <!--              <el-select v-model="statusList" :placeholder="$t('frontPage.pleaseChoose')" class="theme-gray" multiple no-data-text="">-->
          <!--                <el-option v-for="(value,key) in statusArr" :label="$t(`contract_order_status.${value}`)" :value="key" :key="value">{{$t(`contract_order_status.${value}`)}}</el-option>-->
          <!--              </el-select>-->

          <!-- v-if="index<24 || (index>27 && index<=108) || index==111" -->
          <el-select v-model="statusList" :placeholder="$t('frontPage.pleaseChoose')" class="theme-gray" multiple no-data-text="">
            <el-option
              v-for="(item, index) in statusArr"

              :key="item"
              :label="$t(`allorders_status.${item}`)"
              :value="item"
            />
            <!--                过滤掉 24~27 定金审核、一审、二审、定金通过 状态-->
          </el-select>

        </td>
      </tr>
      <tr>
        <td class="td1">
          {{ $t('financing.startTime')+'：' }}
        </td>
        <td class="td2">
          <el-date-picker v-model="pg_stt" :placeholder="$t('loan.selectTime')" style="width: 250px;background: #F5F6F8;border: none" format="yyyy-MM-dd" class="themDefault" type="date"/>
        </td>
        <td class="td3">
          {{ $t('financing.endTime')+'：' }}
        </td>
        <td class="td4">
          <el-date-picker v-model="pg_et" :placeholder="$t('loan.selectTime')" style="width: 250px;background: #F5F6F8;border: none" format="yyyy-MM-dd" class="themDefault" type="date"/>
        </td>
      </tr>
      <tr>
        <td class="td1">
          {{ $t('fancingFundList.flowNum') }}：
        </td>
        <td class="td2">
          <el-input :placeholder="$t('financingFundList.enterPlaceHolder')" v-model.trim="flowNumber" style="width: 250px;" class="theme-gray" maxlength="50"/>
        </td>
        <td class="td3"/>
        <td class="td4"/>
      </tr>
    </table>
    <div class="text-center">
      <div style="margin-top:10px;margin-bottom:30px;" class="centerBtn btn-blue" @click="getList(1)">
        <!--查询-->
        {{ $t('btns.query') }}
      </div>
    </div>

    <el-table :data="dataList" class="dataTable">
      <el-table-column :label="$t('contractManage.orderNum')" width="50" align="left">
        <template slot-scope="scope">
          <span>{{ ((page.pageNo-1) * page.rows) + scope.$index+1 }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('common.applyDate')" width="125">
        <template slot-scope="scope">{{ scope.row.applyTime | dateConvert }}</template>
      </el-table-column>
      <!--      申请日期-->

      <el-table-column :label="$t('flowLists.flowNumber')" prop="flowNumber" width="160"/>
      <el-table-column :label="$t('loan.applyCompany')" :show-overflow-tooltip="true" prop="applyCompany" width="170"/>
      <el-table-column :label="$t('financingFundList.applyMoneyTr')" width="150">
        <template slot-scope="scope">{{ scope.row.applyMoneyType }} {{ scope.row.applyMoney | formatNum }}</template>
      </el-table-column>
      <el-table-column :label="$t('poolOfMoney_page.lockMoney')+'(US$)'" width="165">
        <template slot-scope="scope">
          <!--          {{scope.row.lockMoneyType}}-->
          {{ scope.row.lockMoney | formatNum }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('finacingExamineList.tbTr6')" width="130">
        <template slot-scope="scope">{{ scope.row.financingCurrency }} {{ scope.row.financingMoney }}</template>
      </el-table-column>

      <!-- 申请状态 -->
      <el-table-column :label="$t('loan.status')" width="240" align="left" fixed="right">
        <template v-if="scope.row.applicationStatusList" slot-scope="scope">
          <p
            v-for="(statusItem,index) in scope.row.applicationStatusList"
            v-if="[100,101,1001,1002].indexOf(statusItem.status)==-1"
            :key="index"
            class="item"
          >
            <template v-if="statusItem.loanType==1">
              <span >NO{{ statusItem.sort }} </span>{{ $t(`allorders_status.${statusItem.status}`) }}
              <div v-for="(v,i) in statusItem.creditStatuses" :key="i" style="padding-left:30px;">{{ $t('newrisk.s_ship_data')+ v.sort }}</div>
            </template>
            <template v-if="statusItem.loanType==2">
              <span >NO{{ statusItem.sort }} </span>{{ $t(`allorders_status.${statusItem.status}`) }}

            </template>
            <template v-if="statusItem.loanType==3">
              <span >NO{{ statusItem.sort }} </span>{{ $t(`allorders_status.${statusItem.status}`) }}
              <div v-for="(v,i) in statusItem.creditStatuses" :key="i" style="padding-left:30px;">NO{{ v.sort }}{{ $t(`allorders_status.${v.status}`) }}</div>
            </template>
            <template v-if="!statusItem.loanType">
              {{ $t(`allorders_status.${statusItem.status}`) }}
            </template>
          </p>
        </template>
      </el-table-column>
      <!-- 功能 -->
      <el-table-column :label="$t('contractManage.function')" width="90" align="center" fixed="right">
        <template slot-scope="scope">
          <span class="operate">
            <div v-for="(statusItem,index) in scope.row.applicationStatusList" v-if="statusItem.status<=27" :key="index" class="item">
              <p v-if="statusItem.status===15">
                <router-link :to="{ name: 'financingExamineDetail', query: { in_id: scope.row.flowNumber}}" class="detail">{{ $t('btns.view') }}</router-link>
              </p>
              <p v-else-if="statusItem.status===17 || statusItem.status===18 ||statusItem.status===19">
                <!-- <router-link v-if="hasRight(statusItem.status)&&isApply(statusItem.status)" :to="{ name: 'financingExamineDetail', query: { in_id: scope.row.flowNumber}}" class="detail">{{ $t('btns.apply') }}</router-link>
                <router-link v-else-if="hasRight(statusItem.status)&&isAudit(statusItem.status)" :to="{ name: 'financingExamineDetail', query: { in_id: scope.row.flowNumber}}" class="detail">{{ $t('btns.audit') }}</router-link> -->
                <router-link :to="{ name: 'financingExamineDetail', query: { in_id: scope.row.flowNumber}}" class="detail">{{ $t('btns.view') }}</router-link>
              </p>
              <p v-else-if="statusItem.status===20 || statusItem.status===21 ||statusItem.status===22">
                <router-link :to="{ name: 'financingExamineDetail', query: { in_id: scope.row.flowNumber}}" class="detail">{{ $t('btns.view') }}</router-link>
              </p>
            </div>

            <div v-if="checkStatusNum(scope.row.applicationStatusList)" class="item">
              <p>
                <!-- 申请 -->
                <!-- <router-link v-if="isApplySpecial(scope.row.applicationStatusList)" :to="`/loanDetail?f_n=${scope.row.flowNumber}&menuType=3`" class="btn-link isApply">{{ $t('btns.apply') }}</router-link> -->
                <!-- 审核 -->
                <!-- <router-link v-if="isAuditSpecial(scope.row.applicationStatusList)" :to="`/loanDetail?f_n=${scope.row.flowNumber}&menuType=3`" class="btn-link isAudit">{{ $t('btns.audit') }}</router-link> -->
                <!-- 查看 -->
                <router-link :to="`/loanDetail?f_n=${scope.row.flowNumber}&menuType=3`" class="btn-link isView">{{ $t('btns.view') }}</router-link>
              </p>
            </div>

          </span>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="statusEmpty"><i/>{{ $t('financing.noData') }}</div>
      </template>
    </el-table>

    <el-pagination
      v-show="page.total"
      :total="page.total"
      :page-size="page.rows"
      :current-page.sync="page.pageNo"
      class="page-theme"
      background
      layout="prev, pager, next"
      style="text-align: center;padding-top:30px; padding-bottom: 30px; "
      @current-change="getList(page.pageNo)"/>

  </div>
</template>
<!--0: "all"-->
<!--15: "zma_capitalLock_through"-->
<!--17: "zma_tradeContract_audit"-->
<!--18: "zma_first_tradeContract_audit"-->
<!--19: "zma_second_tradeContract_audit"-->
<!--20: "zma_tradeContract_refuse"-->
<!--21: "zma_tradeContract_close"-->
<!--22: "zma_tradeContract_through"-->
<!--24: "zma_deposit_audit"-->
<!--25: "zma_first_deposit_audit"-->
<!--26: "zma_second_deposit_audit"-->
<!--27: "zma_deposit_through"-->
<!--102: "zma_lending_audit"-->
<!--103: "zma_first_lending_audit"-->
<!--104: "zma_second_lending_audit"-->
<!--105: "zma_lending_refuse"-->
<!--106: "zma_lending_back"-->
<!--108: "zma_lendingInfo_audit"-->
<!--109: "zma_first_lendingInfo_audit"-->
<!--110: "zma_second_lendingInfo_audit"-->
<!--111: "zma_lending_through"-->
<!--112: "zma_waterSingle_audit"-->
<script>
import { mapState } from 'vuex'
import mixins from '@/helper/mixins.js'
import dayjs from 'dayjs'
import $ from 'jquery'
export default {
  name: 'FinancingExamineList',
  components: {},
  mixins: [mixins],
  data() {
    return {
      statusData: {},
      itemArrNum: [],
      statusArr: [0, 15, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 102, 103, 104, 105, 106, 108, 109, 110, 111, 113, 1003, 1004, 1005, 1006, 1007],
      thisTime: '',
      timeArr: [],
      companyName: '',
      flowNumber: '',
      btnLimit: [], // 按钮权限集合
      statusList: [], // 状态
      pg_stt: dayjs(dayjs().subtract(12, 'month').format('YYYY-MM-DD') + ' 00:00:00').toDate(), // 开始时间
      pg_et: dayjs(dayjs().format('YYYY-MM-DD') + ' 23:59:59').toDate(), // 结束时间
      pg_rs: '', // 条数
      pg_st: '', // 当前页码
      dataList: [],
      page: {
        pageNo: 1, // 当前页数
        rows: 10,
        total: 0
      } // 分页数据
    }
  },
  computed: {
    ...mapState(['userProfile']),
    loanName() {
      return this.userProfile.loanName // 登录用户名
    }
  },
  mounted() {
    this.$nextTick(function() {
      const userProfile = parseInt(this.$utils.getStorage('userProfile').isSuper)
      if (userProfile) { // 如果是超级管理员 所有的权限都会有
        this.btnLimit = [1, 17, 18, 19, 24, 25, 26, 102, 103, 104, 108, 109, 110, 113, 140, 150, 160]
      } else {
        this.getMenuLimit(3).then(data => {
          // console.log('getMenuLimit',data)
          this.btnLimit = data
        }) // 获取贷后跟踪下的操作按钮权限
      }
      this.getdiscList()
      document.title = this.$t('loanApplication.loanpayment')
      this.thisTime = new Date()
      this.getList(1)
    })
  },
  methods: {
    // 取字典表的value
    getdiscList() {
      this.axios.get('/static/sysDict/sysDictValue.json')
        .then(res => {
          // console.log('字典表',res);
          // if (res.contract_order_status && res.contract_order_status.en) {
          //   this.statusArr = res.contract_order_status.en
          //   this.statusData = res.all_order_status.en
          //   console.log(this.statusArr, 'this.statusArr')
          // }
        })
        .catch(err => {
          this.$message.error(this.$t(`frontPage.${err.errorCode}`))
        })
    },
    // 列表查询
    getList: function(pageNo) {
      this.page.pageNo = pageNo
      const params = {
        companyName: this.companyName,
        statusList: this.statusList.indexOf('0') > -1 || this.statusList.length < 1 ? '0' : this.statusList.toString(),
        flowNumber: this.flowNumber,
        pg_st: pageNo,
        pg_rs: 10
      }
      if (this.pg_stt) {
        params.startTime = this.pg_stt.toString()
      }
      if (this.pg_et) {
        params.endTime = dayjs(dayjs(this.pg_et).format('YYYY-MM-DD') + '23:59:59').toDate().toString()
      }

      this.axios.post('/zma/api/contractAudit/selectPage', params)
        .then(res => {
          if (res.status) {
            this.page.total = res.data.total
            this.dataList = res.data.rows
          } else {
            this.$message.error(this.$t(`error.${res.errorCode}`))
          }
        })
    },
    hasRight(status) {
      status = parseInt(status)
      if (this.btnLimit.indexOf(status) > -1) {
        return true
      } else {
        return false
      }
    },
    // 是否是申请
    isApply(status) {
      status = parseInt(status)
      if (status === 17 || status === 24 || status === 102 || status === 108 || status === 140) {
        return true
      } else {
        return false
      }
    },
    // 是否是审核
    isAudit(status) {
      status = parseInt(status)
      if (status === 18 || status === 19 || status === 25 || status === 26 || status === 103 || status === 104 || status === 109 || status === 110 || status === 113 || status === 150 || status === 160) {
        return true
      } else {
        return false
      }
    },

    isTrue(status, applycationStatus) {
      return (status == applycationStatus && this.btnLimit.indexOf(applycationStatus) > -1)
    },
    // 是否展示查看
    isViewSpecial(statusList) {
      statusList = Array.isArray(statusList) ? statusList : []
      if ((!this.isAuditSpecial(statusList)) && (!this.isApplySpecial(statusList))) {
        return true
      } else {
        return false
      }
    },
    checkStatusNum(statusList) {
      statusList = Array.isArray(statusList) ? statusList : []
      return this._.some(statusList, (val) => {
        // console.log(val);
        const status = parseInt(val.status)
        if (status > 27) {
          return true
        } else {
          return false
        }
      })
    },
    // 是否展示审核
    isAuditSpecial(statusList) {
      statusList = Array.isArray(statusList) ? statusList : []
      return this._.some(statusList, (val) => {
        // console.log(val);
        const status = parseInt(val.status)
        if (this.isTrue(status, 103) || this.isTrue(status, 104) || this.isTrue(status, 109) || this.isTrue(status, 110) || this.isTrue(status, 113) || this.isTrue(status, 150) || this.isTrue(status, 160)) {
          return true
        } else {
          return false
        }
      })
    },
    // 是否展示申请
    isApplySpecial(statusList) {
      // statusList=[102,120,111];  [{'sort':'','status':1}]
      statusList = Array.isArray(statusList) ? statusList : []
      return this._.some(statusList, (val) => {
        // console.log(val);
        const status = parseInt(val.status)
        if ((this.isTrue(status, 102) || this.isTrue(status, 108) || this.isTrue(status, 140)) && !this.isAuditSpecial(statusList)) {
          return true
        } else {
          return false
        }
      })
    },
    // current_change: function (pageNo) {
    //   this.listDataParagram.pageNo = pageNo;
    //   this.getList();
    // },
    // 起始时间
    // successTimeStart() {
    //   let dt = this.timeArr;
    //   return Array.isArray(dt) && dt.length ? (dt.join().split(','))[0] : '';
    // },
    // // 结束时间
    // successTimeEnd() {
    //   let dt = this.timeArr;
    //   return Array.isArray(dt) && dt.length ? (dt.join().split(','))[1] : '';
    // },
    renderBtn() {
      const itemArrNum = []
      $('.tdOperate').each(function() {
        const isView = $(this).find('.isView').length
        const isAudit = $(this).find('.isAudit').length
        const isApply = $(this).find('.isApply').length
        itemArrNum.push({
          'isView': isView,
          'isApply': isApply,
          'isAudit': isAudit
        })
      })
      console.log('itemArrNum', itemArrNum)
      this.itemArrNum = itemArrNum
      itemArrNum.forEach(function(currentValue, index, arr) {
        console.log($('.tdOperate').eq(index))
        const isView = currentValue.isView
        const isApply = currentValue.isApply
        const isAudit = currentValue.isAudit
        if (isApply > 0) {
          $('.tdOperate').eq(index).find('.isView').remove()
        }
        if (isAudit > 0) {
          $('.tdOperate').eq(index).find('.isView').remove()
        }
        if (isApply >= 2) {
          $('.tdOperate').eq(index).find('.isApply').not(':first').remove()
        }
        if (isAudit >= 2) {
          $('.tdOperate').eq(index).find('.isAudit').not(':first').remove()
        }
        if (isView >= 2) {
          $('.tdOperate').eq(index).find('.isView').not(':first').remove()
        }
        console.log('forEach', currentValue, index, arr)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .formSelect {
    padding: 23px 28px 21px;
  }
  .pr10 {
    padding-right: 10px;
  }

  .formSelect {
    font-size: 14px;
    color: #333333;
  }

  .selectTb{
    table-layout:fixed;
    td{
      font-size: 14px;
      color: #333333;
      padding:10px 30px;
      &.td2{
        padding-right: 10px;
        padding-left: 0;
      }
      &.td4{
        padding-left: 0;
      }
    }
  }

</style>

